import { User, AuthMe } from '@core/models/auth'
import { createReducer, on } from '@ngrx/store'
import {
  login,
  loginFailure,
  loginSuccess,
  logout,
  clearError,
  loadMe,
  loadMeSuccess,
  loadMeFailure,
} from './auth.actions'

export type AuthenticationState = {
  isLoggedIn: boolean
  user: User | null
  error: string | null
  loading: boolean
  me: AuthMe | null
  loadingMe: boolean
  errorMe: string | null
}

const initialState: AuthenticationState = {
  isLoggedIn: false,
  user: null,
  error: null,
  loading: false,
  me: null,
  loadingMe: false,
  errorMe: null,
}

export const authenticationReducer = createReducer(
  initialState,
  on(login, (state) => ({ ...state, error: null, loading: true })),
  on(loginSuccess, (state, { user }) => ({
    ...state,
    isLoggedIn: true,
    user,
    error: null,
    loading: false,
  })),
  on(loginFailure, (state, { error }) => ({ ...state, error, loading: false })),
  on(clearError, (state) => ({ ...state, error: null })),

  on(loadMe, (state) => ({ ...state, loadingMe: true, errorMe: null })),
  on(loadMeSuccess, (state, { me }) => ({
    ...state,
    me,
    // Merge selective fields from detailed profile into lightweight user snapshot
    user: {
      ...(state.user || {}),
      id: me.id,
      name: me.name,
      lastName: (me as any).last_name, // map backend snake_case to camelCase expected in parts of UI
      email: me.email,
    } as User,
    // If we had a token (user/access_token) but hadn't emitted loginSuccess in this session (e.g., page refresh), mark logged in now.
    isLoggedIn: true,
    loadingMe: false,
    errorMe: null,
  })),
  on(loadMeFailure, (state, { error }) => ({
    ...state,
    loadingMe: false,
    errorMe: error,
  })),
  on(logout, (state) => ({
    ...state,
    isLoggedIn: false,
    user: null,
    me: null,
    loading: false,
    loadingMe: false,
    error: null,
    errorMe: null,
  }))
)
